/// <amd-module name="VSS/Platform/CustomerIntelligenceConstants" />
export const START_RIGHT_AREA = "StartRight";

export const START_RIGHT_CREATE_REPO_FEATURE = "CreateRepoRedirect";
export const START_RIGHT_CREATE_PIPELINE_URL_FEATURE = "GetCreatePipelineUrl";
export const START_RIGHT_CREATE_PIPELINE_URL_REPOSITORY_FEATURE = "GetCreatePipelineUrlByRepository";
export const START_RIGHT_CREATE_PIPELINE_URL_FOLDER_FEATURE = "GetCreatePipelineUrlByPipelineFolder";
